import { FC, useState } from 'react';
import cn from 'classnames';
import styles from './OrganizationTextBlockAddPage.module.css';
import { getUUID } from '../../../utils/UUID';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { useNavigate, useParams } from 'react-router-dom';
import Spinner from '../../atoms/Spinner/Spinner';
import { OrganizationTextBlockAddTemplate } from '../../templates';
import { RichTextBlockResponseDto } from '../../../store/buyerAPI/block/dto/response/rich-text-block-response.dto';
import { BlockType } from '../../../store/buyerAPI/block/dto/block-type';
import { RichTextBlockSaveRequestDto } from '../../../store/buyerAPI/block/dto/request/rich-text-block-save-request.dto';
import { EntityType } from '../../../store/buyerAPI/block/entity-type';
import {
  fetchBlocks,
  saveRichTextBlock,
} from '../../../store/buyerAPI/block/reducers/block.slice';

interface OrganizationTextBlockAddPageProps {}

const OrganizationTextBlockAddPage: FC<
  OrganizationTextBlockAddPageProps
> = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { organizationId } = useParams();
  const navigate = useNavigate();
  const [textBlock, setTextBlock] = useState<RichTextBlockResponseDto>({
    content: '',
    blockType: BlockType.RichTextBlock,
    organizationId: organizationId ?? '',
    id: getUUID(),
    versionId: 0,
    createdByUserId: '',
    createdOnDateTimeUtc: '',
    language: '',
    published: true,
  });

  const { richTextBlockStatus: status } = useSelector(
    (state: RootState) => state.organizationBlockSlice
  );

  const handleOnChange = (textBlock: RichTextBlockResponseDto) => {
    setTextBlock(textBlock);
  };

  const callbackFn = async (textBlock: RichTextBlockResponseDto) => {
    const textBlockToSave: RichTextBlockSaveRequestDto = {
      content: textBlock.content,
      blockType: textBlock.blockType,
      organizationId: textBlock.organizationId,
      id: textBlock.id,
      published: textBlock.published,
      entityType: EntityType.Buyer,
      entityId: organizationId ?? '',
    };
    await dispatch(saveRichTextBlock(textBlockToSave));
    dispatch(fetchBlocks(organizationId!));
    navigate(`/organizations/edit/${organizationId}/content-blocks`);
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.wrapper)}>
      <OrganizationTextBlockAddTemplate
        handleOnChange={handleOnChange}
        textBlock={textBlock}
        callbackFn={callbackFn}
      />
    </div>
  );
};

export default OrganizationTextBlockAddPage;
